export default [{"tag":"path","att":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 12.9961v6h2v-6h6v-2h-6v-6h-2v6H5v2h6z"}}]